// extracted by mini-css-extract-plugin
module.exports = {"container":"_4H45H","hero-container":"_3Dlpq","hero-title":"_1xyij","hero-img":"_1ONlm","img-container":"nKqc9","title":"_3_vIC","list":"_1qsJe","list-item":"_1OMfs"};